// Season years are the start year of a "2026-27" style season.
// New rosters go up in the fall (August), and games run February to June.

// Season whose rosters are current: from August on it's the new season.
export const currentSeasonYear = (date = new Date()) =>
  date.getMonth() >= 7 ? date.getFullYear() : date.getFullYear() - 1;

// Most recent season with games played: before February the new season
// hasn't started, so stats come from the season before.
export const statsSeasonYear = (date = new Date()) => {
  const month = date.getMonth();
  return month >= 1 && month <= 6 ? date.getFullYear() - 1 : currentSeasonYear(date) - 1;
};

// 2026 -> "2026-27"
export const seasonLabel = (year) => `${year}-${(year + 1).toString().slice(-2)}`;
